import { NavigationGuard } from 'vue-router';
import store from '@/store';

export const houseSizeResolver: NavigationGuard = async (_to, _from, next) => {
  await store.dispatch('app/updateProcessRoutes');
  await store.dispatch('configuration/setSizes');

  // Try to preload video and images in background
  // and load page in any case of response (don't show video if video couldn't be loaded)
  await Promise.allSettled([store.dispatch('houseSize/preloadVideo'), store.dispatch('houseSize/preloadImages')]);

  next();
};
